import DesignAdvancedForm from './DesignAdvancedForm'

export default DesignAdvancedForm
